// extracted by mini-css-extract-plugin
export var tosLink = "_45-0";